<template>
    <div>
    <b-button-group class="from-to-btn-group" style="width: 100%">
        <b-button
          variant="outline-secondary"
          block
          style="width: 50%; height: 48px; background: #fff"
          @click="onAddRoute"
        >
          <b-row style="margin-top: -6px">
            <b-col cols="1" style="height: 48px">
              <b-icon
                icon="square-fill"
                variant="info"
                font-scale="0.5"
              ></b-icon>
            </b-col>
            <b-col cols="9" style="height: 48px; margin-left: -10px">
              <b-form-text
                class="route-text"
                v-if="origin !== ''"
                style="margin-top: 0.5rem"
              >
                {{ origin }}
              </b-form-text>
              <b-form-text
                class="placeholder-text"
                v-if="origin === ''"
                style="margin-top: 0.5rem"
              >
                {{ $t("message.loadig_city") }}
              </b-form-text>
            </b-col>
          </b-row>
        </b-button>
        <b-button
          variant="outline-secondary"
          style="width: 50%; height: 48px; background: #fff"
          @click="onAddRoute"
        >
          <b-row style="margin-top: -6px">
            <b-col cols="1" style="height: 48px">
              <b-icon
                icon="square-fill"
                variant="secondary"
                font-scale="0.5"
              ></b-icon>
            </b-col>
            <b-col cols="9" style="height: 48px; margin-left: -10px">
              <b-form-text
                class="route-text"
                v-if="destination !== ''"
                style="margin-top: 0.5rem"
              >
                {{ destination }}
              </b-form-text>
              <b-form-text
                class="placeholder-text"
                v-if="destination === ''"
                style="margin-top: 0.5rem"
              >
                {{ $t("message.unLoading_city") }}
              </b-form-text>
            </b-col>
          </b-row>
        </b-button>
      </b-button-group>
       <RouteModal
        @add-route="add_Route"
        :routes_list="routes_list"
        type="multiple"
      />
    </div>
</template>

<script>
import RouteModal from "./modals/LoadRouteModal.vue";

export default {
  name: "RouteFilter",
  components: {
    RouteModal,
  },
  data() {
    return {
      origin: "",
      destination: "",
      routes_list: [],
      routes_dup: {},
    }
  },
  methods: {
    async onAddRoute() {
      this.$root.$emit("on-add-route", null);
    },
    add_Route(route) {
      this.routes_list = route;
      this.routes_dup = route;
      this.origin = route.origin;
      this.destination = route.destination;
      this.demandDetails = [];
      this.currentPage = 0;
      this.pagination = {
        total: 0,
        pageSize: 15,
        currentPage: 0,
        searchAfter: null,
      }

      this.$emit('update-filter', this.routes_list)
    },
  }
}
</script>

<style lang="scss">
@media (max-width: 576px) {
  .demand-details-container {
    padding: 0;
    overflow-y: auto;
    height: 100vh;
    padding-bottom: 50px;
  }

  .load-more-container {
    margin-top: 66px;
  }

  .btn-fixed-bottom-route {
    position: fixed;
    bottom: 0;
    width: 100%;
    margin-left: 1.5%;
    z-index: 5;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 0px;
  }
}
.route-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
}
.placeholder-text {
  text-align: left;
}
.title-text {
  text-align: left;
}
</style>